/**
 * BeforeYouSell
 *
 * Bridge section between StateBreakdown (Courtney quote + market data) and
 * the WorkingCredentials + TourOperatorWarning explainers below. Frames the
 * upcoming two beats as "credentials + the pitfall to avoid" so the agent
 * knows what's coming.
 *
 * Visual format mirrors StateBreakdown — dark teal #0e2727, hairline dividers
 * top and bottom, two-column with vertical divider between. Three dark
 * sections in a row (StateFactsPanel → StateBreakdown → BeforeYouSell), tied
 * together by the consistent divider rhythm, before the page transitions to
 * the champagne explainer block below.
 */
export function BeforeYouSell() {
    return (
        <section className="bg-[#0e2727]">
            <div className="mx-auto max-w-6xl px-6">
                <div className="border-t border-[#F5F5F5]/15 py-10 sm:py-12 lg:py-14">
                    <div className="grid gap-10 md:grid-cols-2 md:gap-0">
                        {/* Left: section heading + standfirst */}
                        <div className="md:pr-10 lg:pr-14">
                            <p className="lux-caps lux-caps-sm text-[#F5F5F5]/55">
                                Beyond licensing
                            </p>
                            <h2
                                className="font-didot mt-4 text-[#E8E0D8]"
                                style={{ fontSize: 'clamp(1.75rem, 2.6vw, 2.25rem)', lineHeight: 1.1 }}
                            >
                                Credentials and network access
                            </h2>
                            <p
                                className="font-didot mt-6 text-[#E8E0D8]/85 italic"
                                style={{
                                    fontSize: 'clamp(1.05rem, 1.4vw, 1.3rem)',
                                    lineHeight: 1.5,
                                    letterSpacing: '0.005em',
                                }}
                            >
                                What makes you a legitimate agency in suppliers&rsquo; eyes &mdash;
                                supplier identifiers, consortium ties, and the third-party
                                endorsements luxury clients increasingly look for.
                            </p>
                        </div>

                        {/* Right: intro paragraph priming the credentials section that follows */}
                        <div className="md:border-l md:border-[#F5F5F5]/15 md:pl-10 lg:pl-14">
                            <p className="leading-[1.75] text-[#E8E0D8]/85 [&_strong]:font-semibold [&_strong]:text-[#E8E0D8]">
                                State licensing is one layer of becoming a travel agent. The other is
                                operational &mdash; the credentials that get you paid, the consortium and
                                supplier-program relationships that unlock preferred rates, and the
                                third-party endorsements that signal credibility to clients. LuxRally
                                provides all of them, so agents inherit access without doing the
                                relationship work themselves.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
